import { fetcher } from '@commenda/utils';

import {
  TIndirectTaxBulkUploadProps,
  TIndirectTaxBulkUploadResponse,
} from './types';

export async function bulkUploadIndirectTaxProducts(
  body: TIndirectTaxBulkUploadProps,
  token?: string
): Promise<{
  success: boolean;
  data?: TIndirectTaxBulkUploadResponse;
  error?: string;
}> {
  try {
    const { signedUrl: _, ...fileWithoutSignedUrl } = body.file;
    const sanitizedBody = {
      ...body,
      file: fileWithoutSignedUrl,
    };

    const response = await fetcher(
      `new-sales-tax/products/bulk/csv`,
      { method: 'POST', body: sanitizedBody },
      token
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to upload products',
      };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to upload products';
    return { success: false, error: errorMessage };
  }
}
